export const reportingYearClosedTitle = "The reporting year is closed.";
export const ReportingYearClosedMessage = () => <>
    {reportingYearClosedTitle}
    Please send the updated Enterprise-level data Excel sheet to the following <a href='mailto:Argidius_EnterpriseLevelDataCollection_Y2022@accenture.com'>email</a> to participate in the 2023 reporting season. </>;